/**
 * Recent Posts widgets Client event and page view handling.
 */

const widgets = document.getElementsByClassName('widget-quickposts');

const quickpostsToggle = () => {
	/**
	 * Because it's a widget we loop through all widgets of that type on the page.
	 */
	Object.entries(widgets).forEach((widget) => {
		const tabs = widget[1].querySelectorAll('.widget-quickposts__tab');
		tabs.forEach((tab) => {
			/**
			 * Click event for tabs on each widget.
			 */
			tab.addEventListener('click', (e) => {
				const isButtonActive = e.target.classList.contains('widget-quickposts--active');
				if (!isButtonActive) {
					/**
					 * Change active state of Recent/Popular tabs.
					 */
					e.target.parentElement.querySelectorAll('.widget-quickposts--active')[0].classList.remove('widget-quickposts--active');
					e.target.classList.add('widget-quickposts--active');

					/**
					 * Change active state of content.
					 */
					const contentWrapper = e.target.parentElement.nextElementSibling;
					const contents = contentWrapper.querySelectorAll('.widget-quickposts__items');
					contents.forEach((content) => {
						if (content.classList.contains('is-active')) {
							content.classList.remove('is-active');
						} else {
							content.classList.add('is-active');
						}
					});
				}
			});
		});
	});
};

export default quickpostsToggle;
